"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonOnboardingExtraDataTypes = void 0;
const keyedRecord_1 = require("../../infrastructure/keyedRecord");
exports.CommonOnboardingExtraDataTypes = (0, keyedRecord_1.keyedRecord)()({});
//# sourceMappingURL=CommonOnboardingExtraDataTypes.js.map